import { render, staticRenderFns } from "./UserMerchantPricing.vue?vue&type=template&id=6fd8d780"
import script from "./UserMerchantPricing.vue?vue&type=script&lang=js"
export * from "./UserMerchantPricing.vue?vue&type=script&lang=js"
import style0 from "./UserMerchantPricing.vue?vue&type=style&index=0&id=6fd8d780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports